(() => {
  const bind = () => {
    document.querySelectorAll(".sdm-acc__trigger").forEach((btn) => {
      if (btn.dataset.sdmBound === "1") return;
      btn.dataset.sdmBound = "1";
      btn.addEventListener("click", () => {
        const item = btn.closest(".sdm-acc__item");
        if (!item) return;
        const open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
  document.addEventListener("shopify:section:load", bind);
})();
